import React, { useState } from 'react';
import ArtistSubscriptionList from '../../components/ArtistSubscriptionList';
import AssignPlanModal from '../../components/AssignPlanModal';

const AdminArtistSubscriptionsPage: React.FC = () => {
  const [showAssign, setShowAssign] = useState(false);
  const [refreshKey, setRefreshKey] = useState(0);

  const handleSuccess = () => { setShowAssign(false); setRefreshKey(k=>k+1); };

  return (
    <div className="p-6">
      <ArtistSubscriptionList key={refreshKey} onAssign={() => setShowAssign(true)} />
      <AssignPlanModal open={showAssign} onClose={() => setShowAssign(false)} onSuccess={handleSuccess} />
    </div>
  );
};

export default AdminArtistSubscriptionsPage;
